import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// ✅ Register User
export const userRegister = createAsyncThunk(
  "user/register",
  async (user, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "https://sl-back-sigma.vercel.app/user/register",
        user
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

// ✅ Login User
export const userLogin = createAsyncThunk(
  "user/login",
  async (user, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "https://sl-back-sigma.vercel.app/user/login",
        user
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

// export const forgotPassword = createAsyncThunk(
//   "user/forgotPassword",
//   async (email, { rejectWithValue }) => {
//     try {
//       const response = await axios.post(
//         "https://sl-back-sigma.vercel.app/api/auth/forgot-password",
//         { email }
//       );
//       return response.data.message; // Returning only success message
//     } catch (error) {
//       return rejectWithValue(
//         error.response?.data || "Erreur lors de l'envoi de l'email"
//       );
//     }
//   }
// );

// ✅ Get Current User
export const getuser = createAsyncThunk(
  "user/current",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        "https://sl-back-sigma.vercel.app/user/current",
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

export const verify2FA = createAsyncThunk(
  "user/verify2FA",
  async ({ email, code }, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        "https://sl-back-sigma.vercel.app/user/verify-2fa",
        {
          email,
          code,
        }
      );

      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.msg || "Erreur de vérification"
      );
    }
  }
);

export const resend2FA = createAsyncThunk(
  "user/resend2FA",
  async (email, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        "https://sl-back-sigma.vercel.app/user/resend-2fa",
        {
          email,
        }
      );
      return res.data.msg;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.msg || "Erreur lors du renvoi"
      );
    }
  }
);

// eedit user
export const editUser = createAsyncThunk(
  "user/edit",
  async ({ id, editProfil }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `https://sl-back-sigma.vercel.app/user/${id}`,
        editProfil,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      return response.data; // the updated user object
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "Failed to update user"
      );
    }
  }
);

export const deleteuser = createAsyncThunk("user/delete", async (id) => {
  try {
    let result = axios.delete(`https://sl-back-sigma.vercel.app/user/${id}`);
    return result;
  } catch (error) {
    console.log(error);
  }
});

// Initial state
const initialState = {
  user: null,
  status: null,
  error: null,
  message: null,
  isAuthenticated: false,
  userList: [],
};

// ✅ Redux Slice
export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    logout: (state) => {
      state.user = null;
      localStorage.removeItem("token");
    },
    clearMessage: (state) => {
      state.message = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // User Registration
      .addCase(userRegister.pending, (state, action) => {
        state.status = "pending";
        state.error = action.payload;
      })
      .addCase(userRegister.fulfilled, (state, action) => {
        state.status = "success";
        state.user = action.payload.user;
        localStorage.setItem("token", action.payload.token);
      })
      .addCase(userRegister.rejected, (state, action) => {
        state.status = "fail";
        state.error = action.payload;
      })

      // User Login
      .addCase(userLogin.pending, (state) => {
        state.status = "pending";
        state.error = null;
      })
      .addCase(userLogin.fulfilled, (state, action) => {
        state.status = "success";
        state.user = action.payload.user;
        state.isAuthenticated = false;
      })
      .addCase(userLogin.rejected, (state, action) => {
        state.status = "fail";
        state.error = action.payload;
      })

      // otp
      .addCase(verify2FA.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(verify2FA.fulfilled, (state, action) => {
        state.loading = false;

        state.token = action.payload.token;
        localStorage.setItem("token", action.payload.token);

        state.user = action.payload.user;
        state.isAuthenticated = true;

        state.success = action.payload.msg;
      })
      .addCase(verify2FA.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(resend2FA.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(resend2FA.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload;
      })
      .addCase(resend2FA.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //   // Forgot Password (NEW)
      //   .addCase(forgotPassword.pending, (state) => {
      //     state.status = "pending";
      //     state.error = null;
      //   })
      //   .addCase(forgotPassword.fulfilled, (state, action) => {
      //     state.status = "success";
      //     state.message = action.payload;
      //   })
      //   .addCase(forgotPassword.rejected, (state, action) => {
      //     state.status = "fail";
      //     state.error = action.payload;
      //   })

      // Edit User (NEW)
      .addCase(editUser.pending, (state) => {
        state.status = "pending";
        state.error = null;
      })
      .addCase(editUser.fulfilled, (state, action) => {
        state.status = "success";
        state.user = action.payload;
      })
      .addCase(editUser.rejected, (state, action) => {
        state.status = "fail";
        state.error = action.payload;
      })

      // get all users
      .addCase(getuser.pending, (state) => {
        state.status = "pending";
        state.error = null;
      })
      .addCase(getuser.fulfilled, (state, action) => {
        state.status = "success";
        state.user = action.payload.data?.user || null;
        state.isAuthenticated = true;
      })
      .addCase(getuser.rejected, (state, action) => {
        state.status = "fail";
        state.userList = [];
        state.error = action.payload;
      })

      // delete user
      .addCase(deleteuser.pending, (state) => {
        state.status = "pending";
        state.error = null;
      })
      .addCase(deleteuser.fulfilled, (state, action) => {
        state.status = "success";
        state.userList = action.payload.data;
      })
      .addCase(deleteuser.rejected, (state, action) => {
        state.status = "fail";
        state.error = action.payload;
      });
  },
});

export const { setUser, logout, clearMessage } = userSlice.actions;
export default userSlice.reducer;
